import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const LockerOpenConfettiIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="#4DB18D"
      fillRule="evenodd"
      d="m160.143 53.43-5.555 6.376a1.53 1.53 0 0 1-2.165.15 1.535 1.535 0 0 1-.149-2.166l5.54-6.376a1.53 1.53 0 0 1 1.65-.454 1.54 1.54 0 0 1 1.051 1.35 1.53 1.53 0 0 1-.372 1.12"
      clipRule="evenodd"
    />
    <path
      fill="#FCCE09"
      fillRule="evenodd"
      d="m195.326 67.855-6.077-5.794a1.53 1.53 0 0 1-.362-1.669 1.54 1.54 0 0 1 1.403-.972 1.54 1.54 0 0 1 1.094.431l6.078 5.869a1.537 1.537 0 1 1-2.136 2.21zM94.123 20.576l2.614-8.034a1.568 1.568 0 1 1 2.986.956l-2.613 8.034a1.568 1.568 0 0 1-2.987-.956M52.579 56.67l6.466-5.42a1.537 1.537 0 0 1 1.986 2.344l-6.481 5.48a1.538 1.538 0 0 1-1.971-2.359z"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m82.804 49.443-2.24-4.032a1.494 1.494 0 0 1 .597-2.091 1.494 1.494 0 0 1 2.09.597l2.24 4.032a1.536 1.536 0 0 1-1.168 2.274 1.54 1.54 0 0 1-1.52-.78"
      clipRule="evenodd"
    />
    <path
      fill="#FCCE09"
      fillRule="evenodd"
      d="m159.696 24.34 8.317-1.494a1.517 1.517 0 1 1 .538 2.987l-8.318 1.493a1.519 1.519 0 0 1-1.515-2.359c.23-.33.581-.556.978-.627M121.406 36.42l1.031 8.393a1.505 1.505 0 0 1-2.987.373l-1.03-8.392a1.503 1.503 0 0 1 2.801-.93c.098.171.161.36.185.557"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m206.825 34.629-.791 4.48a1.516 1.516 0 0 1-2.987-.523l.806-4.48a1.53 1.53 0 0 1 .623-.98 1.5 1.5 0 0 1 1.132-.252 1.517 1.517 0 0 1 1.232 1.755z"
      clipRule="evenodd"
    />
    <path
      fill="#58B694"
      fillRule="evenodd"
      d="m145.3 2.77 4.3 1.657a1.53 1.53 0 0 1 .852.81 1.533 1.533 0 0 1-.781 2.028 1.53 1.53 0 0 1-1.176.03l-4.3-1.658a1.53 1.53 0 0 1-.852-.81 1.533 1.533 0 0 1 .781-2.028 1.54 1.54 0 0 1 1.176-.03"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m32.434 43.888 4.3 1.657a1.537 1.537 0 0 1-1.105 2.867l-4.3-1.642a1.544 1.544 0 0 1 1.105-2.883"
      clipRule="evenodd"
    />
    <path
      fill="#4DB18D"
      fillRule="evenodd"
      d="m12.231 69.364 2.898 7.944a1.536 1.536 0 0 1-2.883 1.06L9.35 70.425a1.535 1.535 0 1 1 2.882-1.06M50.115 13.005l5.585 6.377a1.54 1.54 0 1 1-2.33 2.016L47.8 15.02a1.536 1.536 0 0 1 2.315-2.016"
      clipRule="evenodd"
    />
    <path
      fill="#D40511"
      fillRule="evenodd"
      d="m52.534 91.614-1.493-4.375a1.495 1.495 0 0 1 1-1.941 1.493 1.493 0 0 1 1.927.985l1.493 4.39a1.494 1.494 0 0 1-.986 1.942 1.493 1.493 0 0 1-1.941-1"
      clipRule="evenodd"
    />
    <path
      fill="#58B694"
      fillRule="evenodd"
      d="m221.938 81.474 4.584-.403a1.5 1.5 0 0 1 1.628 1.36 1.51 1.51 0 0 1-.798 1.462 1.5 1.5 0 0 1-.561.165l-4.585.403a1.5 1.5 0 0 1-1.462-.798 1.488 1.488 0 0 1 .177-1.657 1.5 1.5 0 0 1 1.017-.532"
      clipRule="evenodd"
    />
    <path
      fill="url(#dhl__illustrations_lockeropenconfettiillustration_svg_a)"
      d="m78.465 149.675 22.381-4-29.37-14.554-22.352 4.014z"
    />
    <path fill="#C8C8C8" d="M139.577 16.936 71.664 29.128l29.369 14.554 67.914-12.192z" />
    <path fill="#555" d="M100.846 43.495v102.179l-29.37-14.553V28.941z" />
    <path fill="#FBCE08" d="M101.237 44.065v100.95l67.13-12.051V32.013z" />
    <path fill="#C39000" d="m100.91 95.181-.04.391 66.555-11.949v-.383z" />
    <path fill="#FCDE84" d="M101.237 95.48v.796l66.855-12.014v-.795z" />
    <path fill="#393939" d="M135.66 88.904v49.018l31.3-5.619V83.239z" />
    <path fill="#706D6D" d="m135.66 116.793 31.3 15.511-31.3 5.618z" />
    <path fill="#FCDE84" d="m135.662 111.524 3.621 1.799 22.796-4.084-12.976-6.448-13.465 2.412" />
    <path
      fill="url(#dhl__illustrations_lockeropenconfettiillustration_svg_b)"
      d="m135.477 134.56 3.803-.751-3.687-1.828"
    />
    <path fill="#DBB569" d="m135.66 110.183 20.826-3.731-2.159-1.071-18.667 3.325z" />
    <path fill="#C39000" d="m135.635 111.502 3.645 1.812v20.489l-3.636-1.807" />
    <path fill="#FBCE08" d="M139.28 113.314v20.49l22.796-4.085V109.23z" />
    <path fill="#fff" d="M145.957 121.782v7.708l13.309-2.39v-7.707z" />
    <path
      fill="#000"
      d="m153.632 126.612 2.333-.41v-4.597l-2.333.41zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#000"
      d="m147.214 127.736 1.974-.346v-4.598l-1.974.347zm-98.09 21.939h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#000"
      d="m151.373 127.008.971-.171v-4.592l-.971.171zm-102.25 22.667h119.635V16.749H49.124zm0-132.926h119.635v132.926H49.124z"
    />
    <path
      fill="#000"
      d="m158.009 121.245-.991.173v4.598l.991-.173zm-108.885 28.43h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#000"
      d="m150.257 127.207.397-.07v-4.596l-.397.069zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#C39000"
      d="m100.91 119.485-.041.391 34.6-6.237.04-.391zm-51.786 30.19h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.096 119.817v.796l33.956-6.096v-.797zm-51.972 29.858h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#C39000"
      d="M135.045 50.09v.35l33.322-6.01v-.35zm-85.921 99.585h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M135.021 50.442v.794l32.679-5.869v-.795zm-85.897 99.233h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#C39000"
      d="m100.91 82.85-.04.39 66.555-11.949v-.383zm-51.786 66.825h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.042 83.195v.795l67.134-12.046v-.795zm-51.918 66.48h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#C39000"
      d="m100.91 70.593-.04.39 66.555-11.948v-.384zm-51.786 79.082h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.194 70.908v.795l66.982-12.025v-.795zm-52.07 78.767h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#C39000"
      d="M100.87 64.787v.35l66.555-11.948v-.35zm-51.746 84.888h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M101.237 65.058v.795l67.521-12.12v-.794zm-52.113 84.617h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#8E8E8E"
      d="M100.846 144.175v.375l67.912-12.192v-.375zm-51.722 5.5h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#FCDE84"
      d="M134.901 37.57v101.942l.764-.138V37.367zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#555"
      d="m168.758 31.917-.457.082v-.601l-1.333.262v.578L100.846 44.11v3l66.122-11.871v98.15l1.333-.255V34.998l.457-.081zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m105.818 56.37 3.441-.651-.188.282-3.253.617zm-56.694 93.305h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m105.818 55.912 3.791-.719-.188.282-3.603.684zm-56.694 93.763h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m105.818 56.83 3.093-.587-.187.281-2.904.551zm-56.694 92.845h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m131.263 51.792-3.428.65.188-.283 3.238-.615zm-82.14 97.883h119.635V16.749H49.124zm0-132.926h119.635v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m131.263 52.25-3.776.716.187-.281 3.588-.681zm-82.14 97.425h119.635V16.749H49.124zm0-132.926h119.635v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m128.371 51.634 2.89-.549v.247l-3.077.585zm-79.247 98.041h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m109.152 56.444 1.63-2.455 2.027-.384c.224-.043.221.04.111.204l-.413.622c-.057.086-.161.243.184.178l2.714-.516c-.225.342-.956 1.346-2.271 1.595zm-60.028 93.231h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m118.501 53.505-.883 1.333-2.336.443.884-1.332zm-69.377 96.17h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m121.88 52.865-.886 1.33-2.333.445.884-1.333zm-72.756 96.81h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m122.639 52.721-.253.383c-.293.438-.033.836.924.654l3.749-.71.885-1.333zm-73.515 96.954h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m110.288 52.748-.81 1.222 4.43-.84c.224-.042.221.04.112.204-.111.167-.296.456-.409.625-.058.085-.161.241.183.176l1.812-.344s.291-.44.536-.807c.332-.5.027-1.351-1.165-1.126zm-61.164 96.927h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#D30511"
      d="m122.079 52.564-5.712 1.083 1.559-2.347 2.335-.443-.894 1.346 1.042-.198.894-1.345 2.335-.444zm-72.955 97.112h119.634V16.749H49.124zm0-132.927h119.634v132.927H49.124z"
    />
    <path
      fill="#D30511"
      d="m126.871 49.603-1.558 2.347-2.475.47 1.56-2.349zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#8E8E8E"
      d="m167.425 132.221-65.245 11.715v-97.68l65.245-11.714zm-66.579-88.727v102.181l67.912-12.193V31.302zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#C39000"
      d="M135.302 40.923v97.066l.363-.066V40.851zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path
      fill="#555"
      d="M126.147 39.711v1.5l17.311-3.124v-1.5zM49.124 149.675h119.634V16.749H49.124zm0-132.926h119.634v132.926H49.124z"
    />
    <path fill="#FBCE08" d="m197.627 88.905.002 1.079v47.939l-30.811-5.619V83.24z" />
    <path fill="#C39000" d="M197.624 88.905v.374l-30.809-5.648v-.39z" />
    <path fill="#FCDE84" d="M197.627 89.279v.795l-30.809-5.648v-.794z" />
    <defs>
      <linearGradient
        id="dhl__illustrations_lockeropenconfettiillustration_svg_a"
        x1={57.566}
        x2={70.116}
        y1={143.02}
        y2={119.982}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="dhl__illustrations_lockeropenconfettiillustration_svg_b"
        x1={118.742}
        x2={138.971}
        y1={137.578}
        y2={119.879}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.5} stopColor="gray" stopOpacity={0.5} />
        <stop offset={1} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
